// extracted by mini-css-extract-plugin
export default {"PieChartComponent":"pie-chart-component_PieChartComponent__+554u","buttonsBlock":"pie-chart-component_buttonsBlock__V2Wym"};